export enum NoticeTypes {
  INFO = "info",
  WARNING = "warning",
}
